<template>
  <Wrapper>
    <header>{{ $tc('enginesManager.make.create') }}</header>
    <InputStyled :required="!$v.newMake.required">
      <input v-model.trim="$v.newMake.$model" />
    </InputStyled>
    <p class="errors" v-if="$v.newMake.$dirty && !$v.newMake.required">{{ $tc('messages.required') }}</p>
    <ButtonsGroup>
      <ButtonStyled :disabled="$v.newMake.$model === '' || ($v.newMake.$dirty && !$v.newMake.required)" @click="createEngineMake">
        {{ $tc('actions.create') }}
      </ButtonStyled>
      <ButtonStyled color="grey" @click="$root.$emit('closeOverlay')">
        {{ $tc('actions.cancel') }}
      </ButtonStyled>
    </ButtonsGroup>
    <p v-if="pageErrors">
      <span class="error">{{ $tc('error') }}: </span> {{ pageErrors }}
    </p>
  </Wrapper>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { FlashMessages } from '@common/singletons'
import { Wrapper, InputStyled, ButtonsGroup, ButtonStyled } from './styles'
import ASSET_ENGINES_CREATE_MAKE_QUERY from '#/graphql/assetEngines/CreateEngineMake.gql'

export default {
  mixins: [validationMixin],
  props: {
    args: {
      type: Object,
    },
  },
  components: {
    Wrapper,
    InputStyled,
    ButtonsGroup,
    ButtonStyled,
  },
  validations: {
    newMake: {
      required,
    },
  },
  data() {
    return {
      newMake: '',
      pageErrors: '',
    }
  },
  methods: {
    createEngineMake() {
      this.$apollo
        .mutate({
          mutation: ASSET_ENGINES_CREATE_MAKE_QUERY,
          variables: {
            data: {
              code: this.newMake,
            },
          },
        })
        .then(async () => {
          FlashMessages.$emit('success', this.$t('messages.entityCreatedSuccessfully', { entity: this.$t('enginesManager.make.name') }), {
            timeout: 3000,
          })
          this.$root.$emit('closeOverlay')
        })
        .catch(error => {
          this.pageErrors = error?.graphQLErrors[0]?.message
        })
    },
  },
}
</script>
